import { ICommit } from "@/apps/merchant3/shared-models/ICommit";

/**
 * ACTIONS
 */
const actions = {
  setUserLocation: ({ commit }: ICommit, payload: string): void => {
    commit("SET_USER_LOCATION", payload);
  },

  setUserType: ({ commit }: ICommit, payload: string): void => {
    commit("SET_USER_TYPE", payload);
  },

  setUserTag: ({ commit }: ICommit, payload: string): void => {
    commit("SET_USER_TAG", payload);
  },

  setTermsAndConditionsAccepted: (
    { commit }: ICommit,
    payload: boolean
  ): void => {
    commit("SET_TERMS_AND_CONDITIONS_ACCEPT", payload);
  },

  setVersionHash: ({ commit }: ICommit, payload: number): void => {
    commit("SET_VERSION_HASH", payload);
  },

  setPrivacyPolicyAccepted: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_PRIVACY_POLICY_ACCEPT", payload);
  },

  setBackImageURL: ({ commit }: ICommit, payload: string): void => {
    commit("SET_BACK_IMAGE_URL", payload);
  },

  setFrontImageURL: ({ commit }: ICommit, payload: string): void => {
    commit("SET_FRONT_IMAGE_URL", payload);
  },

  setSelfieImageURL: ({ commit }: ICommit, payload: string): void => {
    commit("SET_SELFIE_IMAGE_URL", payload);
  },

  setProofOfAddressImageURL: ({ commit }: ICommit, payload: string): void => {
    commit("SET_PROOF_OF_ADDRESS_IMAGE_URL", payload);
  },

  setPhoneNumber: ({ commit }: ICommit, payload: string): void => {
    commit("SET_PHONE_NUMBER", payload);
  },

  setEmail: ({ commit }: ICommit, payload: string): void => {
    commit("SET_EMAIL", payload);
  },

  setTranscription: (
    { commit }: ICommit,
    payload: {
      cxManualTranscriptionRecorded: boolean;
      nationalIdentificationRecorded: boolean;
    }
  ): void => {
    commit("SET_TRANSCRIPTION", payload);
  },
};

export default actions;
